import { render, staticRenderFns } from "./LifeProgressPanel.vue?vue&type=template&id=ebeceba2&scoped=true&"
import script from "./LifeProgressPanel.vue?vue&type=script&lang=js&"
export * from "./LifeProgressPanel.vue?vue&type=script&lang=js&"
import style0 from "./LifeProgressPanel.vue?vue&type=style&index=0&id=ebeceba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebeceba2",
  null
  
)

/* custom blocks */
import block0 from "./LifeProgressPanel.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports